
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AssistantEmptyProps {
  onRetry: () => void;
}

const AssistantEmpty: React.FC<AssistantEmptyProps> = ({ onRetry }) => {
  return (
    <>
      <Alert className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>No assistants available</AlertTitle>
        <AlertDescription className="text-sm">
          There are currently no assistants available. Please check that the copilot_assistants table in your database is correctly set up and has active entries.
        </AlertDescription>
      </Alert>
      <div className="text-center mt-4">
        <Button variant="outline" size="sm" onClick={onRetry} className="flex items-center gap-2">
          <RefreshCw className="h-4 w-4" />
          <span>Retry</span>
        </Button>
      </div>
    </>
  );
};

export default AssistantEmpty;
